export const toRem = (pixels: number): string => `${pixels * 0.0625}rem`;
